
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import subNav from '~/components/common/subNav.vue'
import textTraderHead from '~/components/textTrader/_head.vue'
import textTraderHeadMobile from '~/components/textTrader/_headMobile.vue'
import textTraderTitleMobile from '~/components/textTrader/_titleMobile.vue'
import textTraderIntro from '~/components/textTrader/_intro.vue'
import textTraderYouQueDian from '~/components/textTrader/_youquedian.vue'
import textLiangDian from '~/components/textTrader/_liangdian.vue'
import textDisclaimer from '~/components/textTrader/_disclaimer.vue'
import textInfluence from '~/components/textTrader/_influence.vue'
// import textExposure from '~/components/textTrader/_exposure.vue'
import textCustomer from '~/components/textTrader/_customer.vue'
import textMarket from '~/components/textTrader/_market.vue'
import textStudy from '~/components/textTrader/_study.vue'
import textSafe from '~/components/textTrader/_safe.vue'
import texthuanjing from '~/components/textTrader/_huanjing.vue'
import textkaihu from '~/components/textTrader/_kaihu.vue'
import textTraderSoftWare from '~/components/textTrader/_traderSoftWare.vue'
import textWebsitePlate from '~/components/textTrader/_websiteplate.vue'
import textMobilePlate from '~/components/textTrader/_mobileplate.vue'
import textDesktopPlate from '~/components/textTrader/_desktopplate.vue'
import dealerMenu from '@/components/textTrader/_menu.vue'
import dealerPinlun from '@/components/dealer/pinglun.vue'
import article from '@/components/textTrader/_article.vue'
import noData from '~/components/common/noData.vue'
import textBottom from '~/components/textTrader/_bottom.vue'
import evaluateDialog from '@/components/detail/evaluateDialog.vue'
import riskWarning from '@/components/dealer/head/riskWarning.vue'
import dealerTisk from '@/components/dealer/head/dealerTisk.vue'
import dealerModule from '@/components/dealer/head/dealerModule.vue'

const _ = require('lodash')

export default {
  components: {
    'sub-nav': subNav,
    'text-head': textTraderHead,
    'text-bottom': textBottom,
    'text-titleMobile': textTraderTitleMobile,
    'text-intro': textTraderIntro,
    'text-YouQueDian': textTraderYouQueDian,
    'text-LiangDian': textLiangDian,
    'text-disclaimer': textDisclaimer,
    'text-influence': textInfluence,
    'text-customer': textCustomer,
    'text-market': textMarket,
    'text-study': textStudy,
    'text-safe': textSafe,
    'text-huanjing': texthuanjing,
    'text-kaihu': textkaihu,
    'text-TraderSoftWare': textTraderSoftWare,
    'text-WebsitePlate': textWebsitePlate,
    'text-MobilePlate': textMobilePlate,
    'text-DesktopPlate': textDesktopPlate,
    'dealer-pinlun': dealerPinlun,
    'dealer-article': article,
    'dealer-menu': dealerMenu,
    'no-data': noData,
    'text-trader-head-mobile': textTraderHeadMobile,
    'evaluate-dialog': evaluateDialog,
    'dealer-tisk': dealerTisk,
    'dealer-module': dealerModule,
    'risk-warning': riskWarning
  },
  provide() {
    return {
      info: this.info && this.info ? this.info : {},
      main: { main: this.info },
      tips: this.tips, // 风险提示
      code: this.info && this.info.code
    }
  },
  async asyncData({ $api, app, store, route, res, $cookies, $serverlog, error }) {
    try {
      const id = route.params.id && route.params.id.split('.')[0]
      const infoTask = $api.dealer
        .textTrader(
          {
            traderCode: id,
            ip: store.state.userIp,
            userId: store.state.user.userId || 0,
            commentLListType: 4,
            customKey: 'texttrader'
          },
          {
            Routes: 'wikifx$wikifxtexttrader'
          }
        )
        .catch((err) => {
          console.log(err)
        })

      const traderTrask = $api.exposure.traderInfo({ traderCode: id })

      const articleTask = $api.common.V3(
        {
          code: id,
          traderCode: id,
          pageindex: 1,
          pagesize: 6
        },
        {
          Routes: 'wikifxarticle$getthirdpartybyrelationid,wikifxagg$whiteStatus'
        }
      )

      // 风险提示
      const tipsmodule = $api.dealer.tips().catch(() => {
        console.log('tipsmodule')
      })

      const fxgradepagelist = $api.home
        .invokev3data(
          {
            // 评价
            pageIndex: 1,
            code: id,
            userLoginId: store.state.user.userId || '',
            searchType: 0,
            pageSize: 2
          },
          {
            Routes: 'wikicommunity$fxgradepagelist,wikicommunity$reportreason'
          }
        )
        .catch(() => {
          console.log('评价')
        })

      const ret = await Promise.all([infoTask, traderTrask, articleTask, tipsmodule, fxgradepagelist])

      let isShow = false
      if (!(ret && ret[0] && ret[0]?.wikifx?.wikifxtexttrader?.data && ret[0]?.wikifx?.wikifxtexttrader?.data?.shortName)) {
        res.statusCode = 404
        isShow = true
      }
      const info = ret[0]?.wikifx?.wikifxtexttrader?.data || {}
      if (info && info.shortName) {
        info.traderCode = id
        info.code = id
      }

      const Trader = ret[1] && ret[1].SearchTraderDetail && ret[1].SearchTraderDetail[0] ? ret[1].SearchTraderDetail[0] : {}

      const navData = [
        {
          link: '/',
          text: '首页',
          type: 'a'
        },
        {
          link: `/dealer/${id}.html`,
          text: '交易商',
          type: 'a'
        },
        {
          link: '#',
          text: '详情',
          type: 'span'
        }
      ]

      if (!info) {
        isShow = true
      }

      const _menu = []
      const tabData = [] // m端tab数据
      if (info.summary && info.summary.content) {
        _menu.push('zhaiyao')
        tabData.push({
          code: 'zhaiyao',
          ico: 'icon-icon-wz-company'
        })
      }
      if (info.advantage && (info.advantage.advantages || info.advantage.disadvantages)) {
        _menu.push('tedian')
        tabData.push({
          code: 'tedian',
          ico: 'icon-Frame-11'
        })
      }
      if (info.safety) {
        _menu.push('safe')
        tabData.push({
          code: 'safe',
          ico: 'icon-Frame-2'
        })
      }
      if (info && info.tradeEnv && info.tradeEnv.Grade) {
        _menu.push('jiaoyihuanjing')
        tabData.push({
          code: 'jiaoyihuanjing',
          ico: 'icon-a-Frame1'
        })
      }
      if (info && info.openAccount && info.openAccount.openAccountInfo) {
        _menu.push('kaihu')
        tabData.push({
          code: 'kaihu',
          ico: 'icon-Frame-4'
        })
      }
      const _tiyan = info && info.softwareInfo && info.softwareInfo.softwareType
      if (_tiyan && [1, 2, 4].includes(_tiyan)) {
        _menu.push('tiyan')
        tabData.push({
          code: 'tiyan',
          ico: 'icon-Frame-5'
        })
      }
      if (_tiyan && [1, 2].includes(_tiyan)) {
        _menu.push('yanjiu')
        tabData.push({
          code: 'yanjiu',
          ico: 'icon-Frame-6'
        })
      }
      const _kehu = info && info.customerService && info.customerService.customerServiceDetail
      if (_kehu && _kehu.length > 0) {
        _menu.push('kehu')
        tabData.push({
          code: 'kehu',
          ico: 'icon-Frame-8'
        })
      }
      if (info.influenceInfo) {
        _menu.push('yinxiangli')
        tabData.push({
          code: 'yinxiangli',
          ico: 'icon-Frame-10'
        })
      }
      // 评论数据
      const _CommentList = ret[4]?.wikicommunity?.fxgradepagelist?.data || {}
      const report = ret[4]?.wikicommunity?.reportreason?.data || []

      const _articles =
        ret[2] && ret[2].wikifxarticle && ret[2].wikifxarticle.getthirdpartybyrelationid && ret[2].wikifxarticle.getthirdpartybyrelationid.data
          ? ret[2].wikifxarticle.getthirdpartybyrelationid.data
          : {} // 新闻列表
      if (_articles && _articles.items && _articles.items.length > 0) {
        _menu.push('wenzhang')
        tabData.push({
          code: 'wenzhang',
          ico: 'icon-icon-wz-history'
        })
      }

      const iswhite = ret[2].wikifxagg?.whitestatus?.data?.isWhite

      if (!iswhite) {
        _menu.push('pinglun')
        tabData.push({
          code: 'pinglun',
          ico: 'icon-Frame-12'
        })
      }

      _menu.push('zongjie')
      tabData.push({
        code: 'zongjie',
        ico: 'icon-Frame-111'
      })

      const tips = ret[3] ? ret[3] : {}

      const _ismt5 = info && info.softwareInfo && info.softwareInfo.softwareType == 2
      const _ismt4 = info && info.softwareInfo && info.softwareInfo.softwareType == 1
      const _isziyan = info && info.softwareInfo && info.softwareInfo.softwareType == 4

      const _advantages = info && info.advantage && info.advantage.advantages ? info.advantage.advantages : []
      const _disadvantages = info && info.advantage && info.advantage.disadvantages ? info.advantage.disadvantages : []

      if (!((info && info.safety && info.safety.regulators && info.safety.regulators.length > 0) || (_articles && _articles.items && _articles.items.length > 0))) {
        res.statusCode = 404
        isShow = true
      }
      return {
        info,
        ismt5: _ismt5,
        ismt4: _ismt4,
        isziyan: _isziyan,
        advantages: _advantages && _advantages.length > 3 ? _advantages.slice(0, 3) : _advantages,
        disadvantages: _disadvantages && _disadvantages.length > 3 ? _disadvantages.slice(0, 3) : _disadvantages,
        Trader,
        articles: _articles,
        iswhite,
        menu: _menu,
        navData,
        traderCode: id,
        CommentList: _CommentList,
        isShow,
        tabData,
        tips,
        report
      }
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      isBottom: false, // pc端滚动是否快到底部
      isFiexd: false, // m端tab组件是否固定定位
      domHeight: 0,
      tabs: [],
      menu: [],
      menuactive: 'zhaiyao',
      info: {},
      traderCode: '',
      CommentList: {},
      pinglun: {},
      articles: [],
      iswhite: false,
      navData: [],
      isShow: false,
      cur: 0,
      lang: this.$store.state.LanguageCode,
      curArrow: 'zhaiyao',
      curArrowShow: false,
      showArrowAll: false, // 全部展开
      extraSty: { isFixed: false }, // 右侧菜单固定悬浮的额外样式
      ismt5: false,
      ismt4: false,
      isziyan: false,
      advantages: [],
      disadvantages: [],
      Trader: {},
      tabData: [],
      tips: {},
      isEvaluateDialog: false, // 开发添加评价弹框
      ourl: '', // 官方网址
      urltype: 'webUrl', // 网址跳转类型
      moduleShow: false, // 弹框是否显示
      iframeurl: '', // iframe地址
      iframeshow: false, // 是否显示iframe
      modelshow: false
    }
  },
  head() {
    const name1 = this.getJysName(this.Trader?.localShortName, this.Trader?.englishShortName, '·', true, true)
    const name2 = this.getJysName(this.Trader?.localShortName, this.Trader?.englishShortName, '·', false, true)
    const _title = this.$t('30558').replace('{1}·{0}', name1).replace('{0}·{1}', name2).replace('{0}', this.info.shortName)
    const _content = this.$t('30559').replace('{1}·{0}', name1).replace('{0}·{1}', name2)
    return {
      title: _title,
      meta: [{ name: 'description', content: _content }]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      tipsheight: 'tipsheight'
    })
  },
  watch: {
    // 监听右侧菜单是否固定
    'extraSty.isFixed'(newVal) {
      const menu = this.$refs.texttradermenu
      if (!menu || this.isBottom < 0) {
        return false
      }
      menu.style.position = newVal ? 'fixed' : 'static' // 最外面盒子是否固定
      menu.style.top = 160 + this.tipsheight + 'px'
    },
    tipsheight(newVal) {
      const menu = this.$refs.texttradermenu
      menu.style.top = 160 + newVal + 'px'
    },
    isMobile(newVal) {
      if (!newVal) {
        this.$forceUpdate()
      }
    },
    // 监听菜单导航栏（移动端）选中项的变化
    menuactive(newV) {
      if (this.isMobile)
        this.$refs.traderTabs.handleNavClick(
          { code: this.menuactive },
          this.tabData.findIndex((item) => item.code == this.menuactive),
          false
        )
    }
  },
  beforeDestroy() {
    window?.removeEventListener('scroll', this.scrollFn)
  },
  mounted() {
    this.domHeight = document.querySelector('.textjys-head')?.offsetHeight + 59
    const that = this
    bus.$on('changeTextTraderMenu', (clickMenu) => {
      that.menuactive = clickMenu.val
      that.changeTab()
    })
    bus.$on('TextTraderArrow', (sa) => {
      this.curArrow = sa.pos
      this.curArrowShow = sa.show
    })
    bus.$on('openurlForTextTrader', (item) => {
      that.openUlr(item)
    })
    that.screenWidth = document.body.clientWidth // 获取屏幕尺寸
    window.addEventListener('resize', (e) => {
      return (() => {
        // 屏幕尺寸变化
        that.screenWidth = document.body.clientWidth
      })()
    })
    window?.addEventListener('scroll', this.scrollFn, { passive: true })

    // console.log('文字版交易商-额外交易商信息', this.Trader)
    console.log('文字版交易商-基础信息', this.info)
  },
  methods: {
    modelshowfn() {
      this.modelshow = false
      this.moduleShow = false
      this.$refs.riskwarning && this.$refs.riskwarning.close()
    },
    openUlr(item) {
      // 官方网址
      const tt = item.url
      if (!item.isLegal) return
      this.matomofn('Wiki_Broker_Detail_Jump', {
        type_click: '官网',
        name: this.info.shortName,
        code: this.traderCode
      })
      this.mdcountfn({
        event_name: 'Wiki_Broker_Detail_Jump',
        type_click: '官网',
        name: this.info.shortName,
        code: this.traderCode
      })
      window.gtag('event', 'click', {
        event_category: 'click',
        event_label: 'click website'
      })
      this.ourl = tt

      window.gtag('event', 'click', {
        event_category: 'click',
        event_label: 'click website'
      })
      if (this.$store.state.allHost.includes('brand=1')) {
        this.statistics('5', tt)
      } else {
        this.statistics('3', tt)
      }
    },
    totype(typeval, type = 'sites') {
      // 跳转方式
      console.log(typeval, 789, this.tips)
      this.returnurl = typeval?.url
      if (this.tips && this.tips.title) {
        setTimeout(() => {
          this.urltype = type
          this.moduleShow = true
          // this.modelshow = true
          this.$nextTick(() => {
            this.$refs.tisk.open()
          })
        }, 0)
      } else if (typeval.type == '0') {
        this.iframeshow = true
        this.modelshow = true
        this.$refs.riskwarning.open()
      } else if (typeval.type == '1') {
        if (!typeval?.url?.includes('mobile/tradertips')) {
          this.closemodefn()
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', typeval?.url)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', typeval?.url)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=1')) {
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=0')) {
          this.modelshow = true
          this.$refs.riskwarning.open()
        }
      }
    },
    close() {
      // 关闭弹框
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.modelshow = false
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    closetisk() {
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    closemodefn() {
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.modelshow = false
      })
    },
    iframeif(val) {
      // iframe显示状态
      console.log(this.returnurl, 777)
      if (val == '0') {
        this.iframeshow = true
        this.modelshow = true
        this.$refs.riskwarning.open()
      } else if (val == '1') {
        if (!this.returnurl?.includes('mobile/tradertips')) {
          this.closemodefn()
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', this.returnurl)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', this.returnurl)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=1')) {
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=0')) {
          this.modelshow = true
          this.$refs.riskwarning.open()
        }
      }
    },
    iframeval(val) {
      // iframe复制
      this.iframeurl = val
    },
    async statistics(type, url, code = '') {
      // 统计type为1--浏览模式默认；type为2---广告点击；3---点击模式官方网址；4---开户网址；5---品专官方网址；6---品专开户地址;7---品专默认
      let spots = 5
      if (type == '3' && !this.$store.state.allHost.includes('brand=1')) spots = 1
      else if (type == '5' && this.$store.state.allHost.includes('brand=1')) spots = 11
      const param = {
        userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
        equipId: this.$Cookie.get('wiki-bfp'),
        platform: 3, // 平台类型
        apptype: 0, // 客户端类型
        ip: this.$store.state.userIp, // 用户ip
        ver: '0', // 版本
        equipinfo: 0, // 客户端类型
        country: this.$store.state.CountryCode, // 当前国家
        lang: this.$store.state.LanguageCode, // 当前语言
        type: 1, // 浏览类型
        code: code || this.traderCode, // 交易商code
        spots, // 点位类型 1网址 3广告 4开户网址 11品专网址 12品专开户网址
        url, // 对应网址
        jumpStatisticsUrl: this.$store.state.allHost
      }
      await this.$api.dealer.statistics(param).then((res) => {
        if (res && res.url) {
          if (type == '5' || type == '3') {
            const u = res.url.includes('http') ? res.url : `https://${res.url}`
            this.iframeval(u)
            this.tipstype = String(res.type)
            this.totype(res)
          }
        }
      })
    },
    getOutPut() {
      const _out = JSON.stringify(this.info)
      return _out
    },
    // m端tab组件子传父方法
    tabFn() {
      if (this.tabData.findIndex((item) => item.code == this.menuactive)) {
        this.isFiexd = true
      }
    },
    // 监听屏幕滚动
    scrollFn() {
      const that = this
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      const startfixed = document.querySelector('.textjys-head')?.clientHeight
      const bodyHeight = document.querySelector('body').clientHeight // 页面总高度
      let menuHeight = document.querySelector('.rightmenu')?.clientHeight // 右侧悬浮盒子高度
      const headHeight = document.querySelector('.wiki-head')?.clientHeight
      const footHeight = document.querySelector('.wiki-foot')?.clientHeight + document.querySelector('.footer-trader')?.clientHeight
      if (menuHeight > 730) {
        menuHeight = 730
      }
      // console.log('menuHeight', menuHeight)
      this.isBottom = bodyHeight - scrollTop - menuHeight - headHeight - footHeight // 页面总高度-右侧悬浮盒子高度-头部高度-尾部高度
      const isReach = scrollTop >= 336 + (startfixed - 294) - 23 // 是否固定
      if (scrollTop > this.domHeight) {
        this.isFiexd = true
      } else {
        this.isFiexd = false
      }
      if (that.menu && that.menu.length > 0) {
        let _ctive = that.menu[0]
        this.menu.forEach((item, k) => {
          const ele = that.$el.querySelector(`#id_${item}`)
          if (ele && scrollTop + 5 > ele.offsetTop + 336 + (startfixed - 294)) {
            _ctive = item
          }
        })

        that.menuactive = _ctive
        // that.moveMenuPosition()
        bus.$emit('changeTextTraderMenu2', _ctive)
      }
      const dom = document.querySelector('.menu')
      if (this.isBottom < 0) {
        dom.style.bottom = 0
        dom.style.top = 'auto'
        dom.style.position = 'absolute'
        _.assign(this.extraSty, { isFixed: false })
      } else {
        dom.style.bottom = 'auto'
        _.assign(this.extraSty, { isFixed: isReach })
      }
    },
    changeTab() {
      const startfixed = document.querySelector('.textjys-head')?.clientHeight
      const piancha = 336 + (startfixed - 294)
      const height = document.querySelector(`#id_${this.menuactive}`)?.offsetTop + piancha
      window?.scrollTo({
        top: this.isMobile ? height + 50 : height,
        behavior: 'instant'
      })
      this.$forceUpdate()
      if (!this.isBottom) this.moveMenuPosition()
    },
    moveMenuPosition() {
      const _index = this.menu.indexOf(this.menuactive)
      const menuright = this.$refs.texttradermenu
      if (this.menu.length > 10) {
        if (_index > 7) {
          menuright.style.top = 'auto'
          menuright.style.bottom = '32px'
        } else {
          menuright.style.top = '160px'
        }
      }
    },
    ZheDieAll() {
      this.showArrowAll = !this.showArrowAll
      if (this.showArrowAll) {
        bus.$emit('TextTraderArrow', {
          pos: 'all',
          show: this.showArrowAll
        })
      } else {
        bus.$emit('TextTraderArrow', {
          pos: 'zhaiyao',
          show: true
        })
      }
    },
    gototop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    },
    PopPingJia() {
      this.isEvaluateDialog = true
    }
  }
}
